<h2 mat-dialog-title>
    @if ($userInfo().isAnonymous) {
        <span i18n>Login or create an account</span>
    } @else {
        <span i18n>Apply for {{ $bookingOptionTitle() }}</span>
    }
</h2>

<mat-dialog-content>

    <rsr-loading [loaded]="$loaded()"></rsr-loading>

    @if ($loaded()) {

        @if ($error()) {
          <rsr-alert variant="error">
            <p>{{ $error() }}</p>
          </rsr-alert>
        }

        @if ($operationInProgress()) {
          <rsr-loading text="Operation in progress" i18n-text></rsr-loading>
        }

        @if ($canApply()) {
        <rsr-alert variant="primary">
          <p i18n>Currently open to applications</p>
        </rsr-alert>
        } @else {
        <rsr-alert variant="warn">
          <p i18n>Currently closed to applications</p>
        </rsr-alert>
        }

        @if (!$userInfo().isAnonymous) {
          @let bookingOptionData = $bookingOptionData();
          <ul>
            <li><span i18n>Status:</span>
              @if ($canApply()) {
                <app-badge variant="success" i18n-title title="Open"></app-badge>
              } @else {
                <app-badge variant="warning" i18n-title title="Closed"></app-badge>
              }
            </li>
            <li><span i18n>Booking item</span>: {{ bookingOptionData.bookingItem?.name }}</li>
            @if (bookingOptionData.venue?.name) {
              <li><span i18n>Where:</span> {{ bookingOptionData.venue?.name }}</li>
            }
            @if (bookingOptionData.summary?.bookingDates.min) {
              <li><span i18n>When:</span>
                {{ bookingOptionData.summary?.bookingDates | easDateRange: timezone: bookingOptionData.summary.bookingDates?.timezone }}
              </li>
            }
            @if (bookingOptionData.summary?.bookingWindow.min) {
              <li><span i18n>Apply from:</span>
                {{ bookingOptionData.summary?.bookingWindow | easDateRange: timezone: bookingOptionData.summary.bookingWindow?.timezone }}
              </li>
            }
            @if (bookingOptionData.summary?.price.min) {
              <li><span i18n>Price: </span>
                <span>{{ bookingOptionData.summary.price| easPriceRange: bookingOptionData.summary.price.currency }}</span>
              </li>
            }
            @if (bookingOptionData?.available_capacity !== -1) {
              <li i18n>Available capacity: {{ bookingOptionData?.available_capacity }}</li>
            }
          </ul>
        }

        @if ($userInfo().isAnonymous) {
          <rsr-alert variant="primary" hideIcon="true">
            <p i18n>
              In order to apply for {{ $bookingOptionTitle() }}, you need to login or create an account.
              <br />
              After you login, you will be able to see if you meet all the eligibility requirements to apply for your chosen exam.
            </p>
          </rsr-alert>

        }

        @if ($eligibilityTree() || $eligiblityDescription()) {
            <h3 i18n>Eligibility requirements</h3>
            <p>{{ $eligiblityDescription() }}</p>
            @if ($eligibilityTree()) {
                @let isEligible = $isEligible();
                <app-badge
                [variant]="isEligible ? 'success' : 'warning'"
                [icon]="isEligible ? 'check' : 'close'"
                size="lg"
                [title]="isEligible ? 'Eligible': 'Not eligible'">
                </app-badge>
            }
        }

    }

</mat-dialog-content>

<mat-dialog-actions>
    @if ($loaded()) {
        @if ($userInfo().isAnonymous) {
            @if ($canApply()) {
                <button mat-flat-button color="primary" (click)="onLogin()" aria-label="Login" i18n>Login or create an account</button>
            }
        } @else {
            @if ($showApply()) {
                <button mat-flat-button color="primary" (click)="onApply()" aria-label="Apply" i18n>Apply</button>
            }
            @if ($userInfo().isRemoteUser) {
                <a mat-flat-button color="accent" matDialogClose [routerLink]="['/users', $userInfo().user, 'apply', bookingItem, bookingOption]" aria-label="View more deetails" i18n>View more details</a>
            } @else {
                <a mat-flat-button color="accent" matDialogClose [routerLink]="['/bookings', 'apply', bookingItem, bookingOption]" i18n aria-label="View more details">View more details</a>
            }
        }
        <button mat-stroked-button (click)="onCancel()" i18n>Cancel</button>
    }
</mat-dialog-actions>
